const e = "headline", n = "headline__overline", i = {
  headline: e,
  headline__overline: n,
  "headline--1": "headline--1",
  "headline--2": "headline--2",
  "headline--3": "headline--3",
  "headline--4": "headline--4",
  "headline--5": "headline--5",
  "headline--6": "headline--6",
  "headline--pipeline": "headline--pipeline",
  "headline--safety": "headline--safety"
};
export {
  i as default,
  e as headline,
  n as headline__overline
};
